import { escapeRegExp, includes } from 'lodash'

const ascending = (a: number, b: number) => a - b

export const addIncrementingSuffix = (
  string: string,
  existing: string[] = [],
  delimiter = '-',
  lowestSuffix = 2,
) => {
  if (!includes(existing, string)) {
    return string
  }

  const stringWithIntSuffix = new RegExp(
    escapeRegExp(string) + '(?:' + escapeRegExp(delimiter) + '(\\d+)$)',
  )
  const usedSuffixes: number[] = existing
    .map(str => {
      const matches = str.match(stringWithIntSuffix)
      return matches && parseInt(matches[1])
    })
    .filter(str => !!str) as number[]

  const highestSuffix: number = usedSuffixes.sort(ascending).pop()!
  const suffix = highestSuffix + 1 || lowestSuffix

  return string + delimiter + suffix
}
